import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';

export const fieldTypes = [
  'TextBox',
  'Number',
  'Date',
  'Location',
  'DateAndTime',
  'URL',
  'Tags',
  'Dropdown',
  'Users',
  'Checkbox',
  'ClientSPOC',
] as const;
export type FieldType = typeof fieldTypes[number];

export const FieldNameMap = {
  TextBox: 'TextBox',
  Number: 'Number',
  Date: 'Date',
  Location: 'Location',
  DateAndTime: 'Date And Time',
  URL: 'URL',
  Tags: 'Tags',
  Dropdown: 'Dropdown',
  Users: 'Users',
  Checkbox: 'Checkbox',
  ClientSPOC: 'Client SPOC',
};

export const FieldIconMap = {
  TextBox: TextFieldsOutlinedIcon,
  Number: PinOutlinedIcon,
  Date: CalendarMonthOutlinedIcon,
  Location: LocationOnOutlinedIcon,
  DateAndTime: AccessTimeOutlinedIcon,
  URL: LinkOutlinedIcon,
  Tags: LocalOfferOutlinedIcon,
  Dropdown: DnsOutlinedIcon,
  Users: GroupOutlinedIcon,
  Checkbox: CheckBoxOutlinedIcon,
  ClientSPOC: GroupOutlinedIcon,
};
